/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { VariableSettingsChangesResponse } from './variableSettingsChangesResponse';
import { VariableSettingDto } from './variableSettingDto';


export interface VariableSettingsResponse { 
    variables?: Array<VariableSettingDto>;
    changes?: VariableSettingsChangesResponse;
    page?: number;
    size?: number;
    gea_puid?: string;
    fetched_at?: string;
    changes_as_of?: number;
    total_elements?: number;
    total_pages?: number;
}

